export function setLanguage(data) {
  return {
    type: 'SETTING_LANGUAGE',
    data,
  }
}



// WEBPACK FOOTER //
// ./src/actions/actions.js